import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import EnvBadge from "@/components/EnvBadge";
import CustomerIdentityPanel from "@/components/superadmin/CustomerIdentityPanel";
import { ArrowLeft, Fingerprint, LogOut } from "lucide-react";

// Dedicated Super Admin section for POS-0034 Customer Identity Protection (relocated out of the
// main Super Admin page). Same role gate as every other /super-admin/* route (see SuperAdminRoute
// in App.js) — presentation/navigation only, no change to the underlying controls, APIs or data.
export default function CustomerIdentityAdmin() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-background" data-testid="customer-identity-admin-page">
      <header className="h-16 border-b border-border bg-card flex items-center justify-between px-6">
        <div className="flex items-center gap-2.5">
          <button onClick={() => nav("/super-admin")} className="p-2 -ml-2 rounded-lg hover:bg-secondary text-muted-foreground" title="Back to Super Admin" data-testid="ci-admin-back">
            <ArrowLeft className="w-5 h-5" />
          </button>
          <div className="w-9 h-9 rounded-xl bg-sky-600 flex items-center justify-center text-white shrink-0">
            <Fingerprint className="w-5 h-5" />
          </div>
          <div>
            <p className="font-head font-bold leading-none flex items-center gap-2 flex-wrap">Customer Identity Protection <EnvBadge showLive /></p>
            <p className="text-[10px] text-sky-600 font-semibold tracking-wider uppercase mt-1">POS-0034 · Super Admin only</p>
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-end gap-2 sm:gap-3">
          <span className="text-sm text-muted-foreground hidden sm:inline">{user?.email}</span>
          <Button variant="ghost" size="icon" onClick={async () => { await logout(); nav("/login"); }} data-testid="ci-admin-logout"><LogOut className="w-4 h-4" /></Button>
        </div>
      </header>

      <div className="p-6 lg:p-8 max-w-[1400px] mx-auto">
        <CustomerIdentityPanel />
      </div>
    </div>
  );
}
